export { default } from "./search";
